import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./index.scss";
import client1 from "../../../assets/images/cl1.png";
import client2 from "../../../assets/images/cl2.png";
import client3 from "../../../assets/images/cl3.png";
import client4 from "../../../assets/images/cl4.png";
import client5 from "../../../assets/images/cl5.png";
import client6 from "../../../assets/images/cl6.png";
import client7 from "../../../assets/images/cl7.png";
import client8 from "../../../assets/images/cl8.png";
import client9 from "../../../assets/images/cl9.png";
import client10 from "../../../assets/images/cl10.png";
import client11 from "../../../assets/images/cl11.png";
import client12 from "../../../assets/images/cl12.png";
import client13 from "../../../assets/images/cl13.png";
import client14 from "../../../assets/images/cl14.png";
import client16 from "../../../assets/images/cl16.png";
import client19 from "../../../assets/images/cl19.png";
import client20 from "../../../assets/images/cl20.png";
import client22 from "../../../assets/images/cl22.png";
import client23 from "../../../assets/images/cl23.png";
import client24 from "../../../assets/images/cl24.png";

const partners = [
  { id: 1, image: client1, alt: "Partner 1" },
  // { id: 2, image: client2, alt: "Partner 2" },
  // { id: 3, image: client3, alt: "Partner 3" },
  // { id: 4, image: client4, alt: "Partner 4" },
  // { id: 5, image: client5, alt: "Partner 5" },
  { id: 6, image: client6, alt: "Partner 6" },
  // { id: 7, image: client7, alt: "Partner 7" },
  // { id: 8, image: client8, alt: "Partner 8" },
  { id: 9, image: client9, alt: "Partner 9" },
  // { id: 10, image: client10, alt: "Partner 10" },
  { id: 11, image: client11, alt: "Partner 11" },
  { id: 12, image: client12, alt: "Partner 12" },
  // { id: 13, image: client13, alt: "Partner 13" },
  { id: 14, image: client14, alt: "Partner 14" },
  { id: 16, image: client16, alt: "Partner 16" },
  { id: 19, image: client19, alt: "Partner 19" },
  { id: 20, image: client20, alt: "Partner 20" },
  { id: 22, image: client22, alt: "Partner 22" },
  { id: 23, image: client23, alt: "Partner 23" },
  { id: 24, image: client24, alt: "Partner 24" },
];

export default function PartnersSection() {
  const { t } = useTranslation();

  // Duplicate partners for seamless loop
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section className="partners-section">
      <Container>
        <h2 className="partners-title">
          {t("partners.title", "Ils nous font")}
          <br />
          {t("partners.title2", "confiance")}
        </h2>
        
        <div className="partners-slider-wrapper">
          <div className="partners-slider">
            {duplicatedPartners.map((partner, index) => (
              <div key={`${partner.id}-${index}`} className="partner-logo">
                <img src={partner.image} alt={partner.alt} />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}


